import Image from 'next/image';
import Link from 'next/link';

import { useAppContext } from 'hooks/context/useAppContext';
import { ThemeModes, useGGTheme } from 'hooks/theme/useGGTheme';

import s from './OrganicMinimalHeader.module.css';

export const OrganicMinimalHeader = () => {
  const { publicUser } = useAppContext();
  const { themeMode } = useGGTheme();

  const logoUrl =
    themeMode === ThemeModes.DARK
      ? '/assets/logos/GG_Logo_White.svg'
      : '/assets/logos/GG_Logo_Black.svg';

  return (
    <header>
      <div className={s.logo}>
        <a href="https://glossgenius.com" target="_blank" rel="noreferrer">
          <Image src={logoUrl} width="163" height="26" alt="GlossGenius" />
        </a>
      </div>
      <h1 className={s.heading}>
        <Link href="/">{publicUser?.business_name || ''}</Link>
      </h1>
    </header>
  );
};
